import * as React from 'react';

import { compose } from 'recompose';

import DefaultHeader from 'bundles/composable-page-header-consumer/header-renderers/DefaultHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import withFetchLazyImages from 'bundles/page/components/shared/utils/withFetchLazyImages';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!bundles/unified-description-page-common/__styles__/index';

type Props = {
  children?: JSX.Element;
};

const ConsumerPageWrapper = ({ children }: Props) => {
  return (
    <React.Fragment>
      <DefaultHeader isPositionStatic />
      <UniversalPageFeatures />
      {children}
      <PageFooter isStickyBarPresent />
    </React.Fragment>
  );
};

export default compose<Props, {}>(withMarketingConsent, withFetchLazyImages)(ConsumerPageWrapper);
